import { ADICIONAR_FILTRO_CTE_OS, LIMPAR_FILTRO_CTE_OS, LISTAR_FILTROS_CTE_OS, REMOVER_FILTRO_CTE_OS } from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

const initialState = undefined

const initial = {}

export const filtrosAdicionadosCteOs = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_CTE_OS: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_CTE_OS: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    case LIMPAR_FILTRO_CTE_OS: {
      return []
    }

    default:
      return state
  }
}

export const filtrosCteOs = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_CTE_OS: {
      return action.payload.data
    }
    default:
      return state
  }
}
